import { render, staticRenderFns } from "./RequestsDashboardCard.vue?vue&type=template&id=daf52050"
import script from "./RequestsDashboardCard.vue?vue&type=script&lang=js"
export * from "./RequestsDashboardCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports